var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNlg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#2AB0FD"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M25.515 14.804c.165-.002.27.02.336.08.07.064.098.168.113.331.466 5.379-3.602 10.241-8.998 10.74-5.564.515-10.394-3.5-10.922-9.08C5.53 11.456 9.599 6.54 15.03 6.046c3.076-.28 5.732.686 7.968 2.816.023.022.018.114-.008.14a119.48 119.48 0 01-1.52 1.521c-.029.028-.133.024-.165-.005-2.307-2.114-4.98-2.74-7.903-1.675C10.446 9.92 8.755 12.15 8.42 15.29c-.45 4.249 2.757 7.994 7.035 8.317 3.878.292 7.392-2.453 8.035-6.285.006-.038-.08-.133-.124-.133-2.395-.007-4.79-.005-7.184-.014-.062 0-.177-.115-.179-.178a53.477 53.477 0 010-2.008c.001-.06.108-.168.167-.169 1.596-.009 7.826.005 9.344-.017z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNlg);
export default __webpack_public_path__ + "static/media/nlg.b2c01f87ff191cd7dde0cdf0d71d7a4b.svg";
export { ForwardRef as ReactComponent };